import React from "react";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import { CallToActionContextType, useCallToActionContext } from "@contexts/CallToActionContext";
import { UpgradeCTASource } from "@user/AmplitudeProSubsEvents";
import SubscriptionTierBlock from "./SubscriptionTierBlock";

const UPGRADE_BTN_LABEL = "Upgrade 🚀";

interface StripeSubscriptionUpgradeButtonsProps {
    isVisible: boolean;
}
export default function StripeSubscriptionUpgradeButtons(props: StripeSubscriptionUpgradeButtonsProps) {
    const { setUpgradeCtaContext }: CallToActionContextType = useCallToActionContext();

    const btn = (
        <SpecialLifeAtButton
            isLink={false}
            text={UPGRADE_BTN_LABEL}
            handleClick={() => {
                setUpgradeCtaContext("default", UpgradeCTASource.UPGRADE_BUTTON);
            }}
            variant={"blue"}
            shape={"pill"}
        />
    );

    return props.isVisible ? <SubscriptionTierBlock isVisible={true} buttonComponent={btn} /> : null;
}
